import {z} from "zod"

export const sourceSchema = z.enum(["prod", "qa", "dev", "dev2", "dev3", "dev4", "dev5", "qa2", "local"])
export type Source = z.infer<typeof sourceSchema>

export const configuratorWcModuleUrls: Record<Source, string> = {
    prod: "https://configurator.colormass.com/cm-configurator.js",
    dev: "https://configurator-dev.colormass.com/cm-configurator.js",
    dev2: "https://configurator-dev2.colormass.com/cm-configurator.js",
    dev3: "https://configurator-dev3.colormass.com/cm-configurator.js",
    dev4: "https://configurator-dev4.colormass.com/cm-configurator.js",
    dev5: "https://configurator-dev5.colormass.com/cm-configurator.js",
    qa: "https://configurator-qa.colormass.com/cm-configurator.js",
    qa2: "https://configurator-qa2.colormass.com/cm-configurator.js",
    local: "http://localhost:4300/cm-configurator.js",
}

export const configuratorAppUrls: Record<Source, string> = {
    prod: "https://configurator.colormass.com",
    dev: "https://configurator-dev.colormass.com",
    dev2: "https://configurator-dev2.colormass.com",
    dev3: "https://configurator-dev3.colormass.com",
    dev4: "https://configurator-dev4.colormass.com",
    dev5: "https://configurator-dev5.colormass.com",
    qa: "https://configurator-qa.colormass.com",
    qa2: "https://configurator-qa2.colormass.com",
    local: "http://localhost:4300",
}

export const materialDownloadUrls: Record<Source, string> = {
    prod: "https://material-download.colormass.com",
    dev: "https://cm-material-download-dev.web.app",
    dev2: "https://cm-material-download-dev2-6aa17.web.app",
    dev3: "https://cm-material-download-dev3.web.app",
    dev4: "https://cm-material-download-dev4.web.app",
    dev5: "https://cm-material-download-dev5.web.app",
    qa: "https://cm-material-download-qa-b6f44.web.app",
    qa2: "https://cm-material-download-qa2.web.app",
    local: "http://localhost:8080",
}
